import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const FREE_SHIPPING = 250;
const SHIPPING_COST = 25;

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("vb_cart")) || []; }
    catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("vb_cart", JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.product_id === product.id);
      if (found)
        return prev.map((i) =>
          i.product_id === product.id ? { ...i, quantity: i.quantity + qty } : i);
      return [...prev, {
        product_id: product.id, name: product.name, price: product.price,
        image: product.image, quantity: qty,
      }];
    });
    setOpen(true);
  };

  const remove = (pid) => setItems((prev) => prev.filter((i) => i.product_id !== pid));
  const setQty = (pid, qty) =>
    setItems((prev) =>
      prev.map((i) => (i.product_id === pid ? { ...i, quantity: Math.max(1, qty) } : i)));
  const clear = () => setItems([]);

  const totals = useMemo(() => {
    const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
    const shipping = subtotal >= FREE_SHIPPING || subtotal === 0 ? 0 : SHIPPING_COST;
    const count = items.reduce((s, i) => s + i.quantity, 0);
    return { subtotal, shipping, total: subtotal + shipping, count,
      freeShippingThreshold: FREE_SHIPPING,
      freeShippingRemaining: Math.max(0, FREE_SHIPPING - subtotal) };
  }, [items]);

  return (
    <CartContext.Provider value={{ items, open, setOpen, add, remove, setQty, clear, totals }}>
      {children}
    </CartContext.Provider>
  );
}
